// extracted by mini-css-extract-plugin
export var messageSideLeft = "_js-1";
export var messageSideRight = "_js-2";
export var orderLookupBubbleContainer = "_js-0";
export var submitButton = "_js-3";